import type { RouteLocationNormalized } from 'vue-router'
import { RouteName } from './routeNames'
import { routeNamesDebug } from './routesDebug'
import { isErrorRoute } from './routerErrors'

const routeNamesNoGuards = [
  RouteName.FAQ,
  RouteName.TermsOfUse,
  RouteName.Feedback,
  RouteName.FeedbackSubmitted,
  RouteName.CustomForm,
  ...routeNamesDebug
]

export function shouldApplyRouteGuard(to: RouteLocationNormalized): boolean {
  if (isErrorRoute(to)) return false

  for (const routeName of routeNamesNoGuards) {
    if (routeName === to.name) {
      return false
    }
  }

  return true
}
